export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_05.c6101744.jpg";